import { API_URL } from '$lib/conf'
import { readAthTable, getDateObj, sleep } from '$lib/utils'
import user from '../stores/user'

const getURL = ({suffix, query, id}) => `${API_URL}/${suffix}/${user.currentAccount}${id ? '/' + id : ''}${query ? '?' + new URLSearchParams(query).toString() : ''}`
    .replace(/\/{2,}/g, '/')
    .replace(/(https?):\//, '$1://')

export class BaseInterface {
        // Statics methods
        static get suffix() {return ''}
        
        static backup = true

        static URL({id = null, query = null}) { return getURL({suffix: this.suffix, id, query}) }

        static syncQuery(date) { return {'modified_date[gt]': date.replace('Z', '+0000')}}
        
        static getFetch({options={}, id = null, query = null}) {
            return user.fetch(this.URL({id, query}), options)
        }
        
        static convert(entry) {
            return entry
        }
        
        static toItem(data) {
            return data || []
        }
    
        static get(query = null) {
            return this.getFetch({
                    options: {
                        method: 'GET',
                    },
                    query
                }
            )
        }
    
        static getById(id) {
            return this.getFetch({
                    options: {
                        method: 'GET',
                    },
                    id
                }
            )
        }
    
        static add(item) {
            return this.getFetch(
                {
                    options :{
                        method: 'POST',
                        body: JSON.stringify(item),
                    }
                }
            )
        }
    
        static async count(query={}) {
            let { count=null } = await this.getFetch({query: {...query, limit: 0}}).then(async r => r.json())
            return count
        }

        static sync(collection, since = 0) {
            let date = new Date(since * 1000).toISOString().replace('Z', '+0000')
            let query = this.syncQuery(date)
            return this.getFetch(
                {
                    options: {
                        method: 'GET',
                    },
                    query
                }
                )
                .then(async (r) => {
                    if (r.ok) {
                        let { data } = await r.json()
                        data.forEach((item) => {
                            collection.put(this.convert(item))
                        })
                    }
                    return r
                })
        }
    
}

// @ts-ignore
export class Invoice extends BaseInterface {
    // Statics methods
    static get suffix() { return 'invoices' }
    static convert(entry) {
        return {
            ...entry,
            id_ath: entry.id,
            cuit: user.currentAccount,//user.subscribe((u) => u.defaultAccount),
            ref: `${entry.tipo_comprobante || ''}${(entry.punto_de_venta || '').padStart(5, '0')}${(entry.nro_comprobante || '').padStart(8, '0')}`,
            fecha_creacion: new Date(entry.fecha_creacion).valueOf() / 1000,
            importe_total: parseFloat(entry.importe_total) || 0,
            importe_neto: parseFloat(entry.importe_neto) || 0,
            moneda: ['USD', 'EUR', 'ARS'].includes(entry.moneda)
                ? entry.moneda
                : {
                      PES: 'ARS',
                      PESOS: 'ARS',
                      DOL: 'USD',
                  }[entry.moneda],
            fecha_modificacion:
                new Date(entry.fecha_modificacion).valueOf() / 1000,
            id: entry.link.split('/').at(-1),
            orden_de_compra: readAthTable(entry.orden_de_compra).map(
                (x) => x.Numero_de_Orden
            ),
        }
    }

    static toItem(returnedFetchData) {
        return returnedFetchData?.data || []
    }
    
    static syncQuery(date) { return { 'fecha_modificacion[gt]': date } }
    
    static async batchInitialization({count=null, size=20, page=0, delay=0}) {
        if (typeof count != 'number') {
            count = await this.count()
        }
        const postProcess = async r => await r.json()
            .then(d => this.toItem(d))
            .then(d => d.map(e => this.convert(e)))
        let totalPages = Math.ceil(count/size)
        let firstBatch = this.get({ limit: size, page }).then(postProcess)
        const selfClass = this
        let restBatchsBuilder = (initialIter, total, limit, mclass, thenFunc, awaitTime) => async function* () {
            let iter = initialIter
            while (iter <= total) {
                console.log(`Sync Page ${iter} of ${total}`)
                try {
                    if(awaitTime) await sleep(awaitTime);
                    yield await mclass.get({ limit, page: iter }).then(thenFunc)
                    iter++
                } catch (e) {
                    break
                }
            }
        }
        return [firstBatch, restBatchsBuilder(1, totalPages, size, selfClass, postProcess, delay)]
    }

    // static sync(collection, since = 0) {
    //     let date = new Date(since * 1000).toISOString().replace('Z', '+0000')
    //     return this.getFetch(
    //         {
    //             options: {
    //                 method: 'GET',
    //             },
    //             query: { 'fecha_modificacion[gt]': date }
    //         }
    //         )
    //         .then(async (r) => {
    //             if (r.ok) {
    //                 let { data } = await r.json()
    //                 data.forEach((item) => {
    //                     collection.put(this.convert(item))
    //                 })
    //             }
    //             return r
    //         })
    // }
}
export class DamageInvoice {
    // Statics methods
    static backup = true
    static URL = ({id = null, query = null}) => {
        // return user.subscribe(u => `${API_URL}/invoices_sin/${u?.defaultAccount}${id ? '/' + id : ''}${query ? '?' + new URLSearchParams(query).toString() : ''}`)
        return `${API_URL}/invoices_sin/${user.currentAccount}${id ? '/' + id : ''}${query ? '?' + new URLSearchParams(query).toString() : ''}`
    }
    static getFetch = ({options={}, id = null, query = null}) => {
        return user.fetch(this.URL({id, query}), options)
    }
    static convert(data) {
        return {
            id: data.uuid,
            fecha_modificacion: Math.floor(
                new Date(data.modified_date).getTime() / 1000
            ),
            ...data,
        }
    }

    static toItem(returnedFetchData) {
        return returnedFetchData?.data || []
    }

    static get(query = null) {
        return this.getFetch({
                options: {
                    method: 'GET',
                },
                query
            }
        )
    }

    static getById(id) {
        return this.getFetch({
                options: {
                    method: 'GET',
                },
                id
            }
        )
    }

    static add(item) {
        return this.getFetch(
            {
                options :{
                    method: 'POST',
                    body: JSON.stringify(item),
                }
            }
        )
    }

    static update(id, data) {
        return this.getFetch({
                options: {
                    method: 'PUT',
                    body: JSON.stringify(data),
                },
                id
            }
        )
    }

    static async count(query={}) {
        let { count=null } = await this.getFetch({query: {...query, limit: 1}}).then(r => r.json())
        return count
    }

    static sync(collection, since = 0) {
        let date = new Date(since * 1000).toISOString().replace('Z', '+0000')
        return this.getFetch({
            options: {
                method: 'GET'
            },
            query: { 'modified_date[gt]': date }
        })
        .then(async (r) => {
            if (r.ok) {
                let { data } = await r.json()
                data.forEach((item) => {
                    collection.put(this.convert(item))
                })
            }
            return r
        })
    }

    // static async batchInitialization({count=null, size=20, page=0, delay=0}) {
    //     if (typeof count != 'number') {
    //         count = await this.count()
    //     }
    //     const postProcess = async r => await r.json()
    //         // .then(d => {console.log(d); return d})
    //         .then(d => this.toItem(d))
    //         .then(d => d.map(e => this.convert(e)))
    //     let totalPages = Math.ceil(count/size)
    //     let firstBatch = this.get({ limit: size, page }).then(postProcess)
    //     const selfClass = this
    //     let cdate = new Date()
    //     let restBatchsBuilder = (initialIter, total, limit, mclass, thenFunc, awaitTime) => async function* () {
    //         let iter = initialIter
    //         while (iter <= total) {
    //             console.log(`[${selfClass.name}] Sync Page ${iter} of ${total}`)
    //             try {
    //                 if(awaitTime) await sleep(awaitTime);
    //                 yield await mclass.get({ limit, page: iter, 'creation_date[lte]': cdate.toISOString() }).then(thenFunc)
    //                 iter++
    //             } catch (e) {
    //                 break
    //             }
    //         }
    //     }
    //     return [firstBatch, restBatchsBuilder(1, totalPages, size, selfClass, postProcess, delay)]
    // }

    static download(id, preview = false) {
        return `${API_URL}/download/${id}${preview ? 'preview' : ''}`
    }
}
export class Tranfer extends BaseInterface {
    // Statics methods
    static get suffix() { return 'tranfers' }
    // static URL = (id = null, query = null) => {
    //     return `${API_URL}/tranfers${id ? '/' + id : ''}${query ? '?' + new URLSearchParams(query).toString() : ''}`
    // }
    // static getFetch = (options, id = null, query = null) => {
    //     return fetch(this.URL(id, query), {
    //         ...options,
    //         headers: {
    //             ...headers,
    //             ...(options?.headers || {}),
    //         },
    //     })
    // }
    static convert(data) {
        return {
            ...data,
            cuit: user.currentAccount,//user.subscribe((u) => u.defaultAccount),
            fecha_comprobante: data.fecha.substring(0, 10),
            fecha: Math.floor(getDateObj(data.fecha)?.getTime() / 1000),
            fecha_creacion: new Date(data.fecha_creacion).valueOf() / 1000,
            importe: parseFloat(data.importe.replace('$ ', '')) || 0,
            fecha_modificacion:
                new Date(data.fecha_modificacion).valueOf() / 1000,
        }
    }

    static toItem(returnedFetchData) {
        return returnedFetchData?.data || []
    }

    static async batchInitialization({count=null, size=20, page=0, delay=0}) {
        if (typeof count != 'number') {
            count = await this.count()
        }
        const postProcess = async r => await r.json()
            // .then(d => {console.log(d); return d})
            .then(d => this.toItem(d))
            .then(d => d.map(e => this.convert(e)))
        let totalPages = Math.ceil(count/size)
        let firstBatch = this.get({ limit: size, page }).then(postProcess)
        const selfClass = this
        let restBatchsBuilder = (initialIter, total, limit, mclass, thenFunc, awaitTime) => async function* () {
            let iter = initialIter
            while (iter <= total) {
                console.log(`Sync Page ${iter} of ${total}`)
                try {
                    if(awaitTime) await sleep(awaitTime);
                    yield await mclass.get({ limit, page: iter }).then(thenFunc)
                    iter++
                } catch (e) {
                    break
                }
            }
        }
        return [firstBatch, restBatchsBuilder(1, totalPages, size, selfClass, postProcess, delay)]
    }
}

// @ts-ignore
export class Withholding extends BaseInterface {
    // Statics methods
    static get suffix() { return 'withholdings' } 
    static syncQuery(date){ return { 'fecha_modificacion[gt]': date }}
    static convert(data) {
        return {
            ...data,
            cuit: user.currentAccount,//user.subscribe((u) => u.defaultAccount),
            fecha_pago: data.fecha.replaceAll('.', '/'),
            // fecha: Math.floor(getDateObj(data).getTime() / 1000),
            fecha_creacion: new Date(data.fecha_creacion).valueOf() / 1000,
            // importe: parseFloat(data.importe.replace('$ ','')) || 0,
            fecha_modificacion:
                new Date(data.fecha_modificacion).valueOf() / 1000,
        }
    }

    static toItem(returnedFetchData) {
        return returnedFetchData?.data || []
    }

    static async batchInitialization({count=null, size=20, page=0, delay=0}) {
        if (typeof count != 'number') {
            count = await this.count()
        }
        const postProcess = async r => await r.json()
            // .then(d => {console.log(d); return d})
            .then(d => this.toItem(d))
            .then(d => d.map(e => this.convert(e)))
        let totalPages = Math.ceil(count/size)
        let firstBatch = this.get({ limit: size, page }).then(postProcess)
        const selfClass = this
        let restBatchsBuilder = (initialIter, total, limit, mclass, thenFunc, awaitTime) => async function* () {
            let iter = initialIter
            while (iter <= total) {
                console.log(`Sync Page ${iter} of ${total}`)
                try {
                    if(awaitTime) await sleep(awaitTime);
                    yield await mclass.get({ limit, page: iter }).then(thenFunc)
                    iter++
                } catch (e) {
                    break
                }
            }
        }
        return [firstBatch, restBatchsBuilder(1, totalPages, size, selfClass, postProcess, delay)]
    }
}

export class Licitacion {
    static backup = false
    static convert(data) {
        return {
            ...data,
            fecha_modificacion: Math.floor(
                new Date(data.modified_date).getTime() / 1000
            ),
            cuit: user.currentAccount//user.currentAccount,
        }
    }
    static add(item) {
        return item
    }
    // static proveedor_cuit =  || ''
    static getToken() {
        return user.token
    }
    static get() {
        return user.fetch(
            `${API_URL}/tenders/${user.currentAccount}`
        )
    }

    static async sync(collection, _) {
        return Licitacion.get().then(async (r) => {
            if (r.ok) {
                let data = await r.json()
                let ids = data.map((i) => i.id)
                await collection.where('id').noneOf(ids).delete()
                data?.forEach(async (item) => {
                    collection.put(this.convert(item))
                })
                return r
            } else {
                throw new Error('Error al sincronizar licitaciones.')
            }
        })
    }

    static getById(id) {
        let [Id, _] = id instanceof Array ? id : [id]
        return user.fetch(
            `${API_URL}/tenders/${user.currentAccount}/${Id}`
        )
    }

    static async count(query={}) {
        let { count=null } = await user.fetch(
            `${API_URL}/tenders/${user.currentAccount}`
        ).then(r => r.json())
        return count
    }
}

export class Oferta {
    static backup = true
    static URL({id = null, query = null}) { return getURL({suffix: 'offers2', id, query}) }
    static getFetch = ({options={}, id = null, query = null}) => {
        return user.fetch(this.URL({id, query}), options)
    }
    static convert(data) {
        return {
            fecha_modificacion: Math.floor(
                new Date(data.modified_date).getTime() / 1000
            ),
            cuit: user.currentAccount,
            ...data,
        }
    }

    static toItem(returnedFetchData) {
        return returnedFetchData?.data || []
    }

    static defaultfields() {
        return [
            'id',
            'id_siniestro',
            'id_licitacion',
            'licitacion',
            'vehiculo.marca',
            'vehiculo.modelo',
            'vehiculo.patente',
            'sucursal_nombre',
            'monto_total',
            'state',
            'creation_date',
            'modified_date'
        ]
    }

    static get(query = {}) {
        query = {...query,
            fields: this.defaultfields().join(','),
        }
        return this.getFetch({
                options: {
                    method: 'GET',
                },
                query
            }
        )
    }

    static getById(id) {
        return this.getFetch({
                options: {
                    method: 'GET',
                },
                id,
                query: {
                    fields: 'id,id_oferta,id_licitacion,id_siniestro,state,siniestro,codigo_infoauto,sucursal_nombre,licitacion,factura,claims,creation_date,modified_date,offer_modifications,monto_total,tiempo_entrega,items,asegurado,vehiculo,siniestro'
                }
            }
        )
    }

    static add(item) {
        //TODO REVISAR
        return this.getFetch({
                options: {
                    method: 'POST',
                    body: JSON.stringify(item),
                }
            }
        )
    }

    static update(id, item) {
        return this.getFetch({
                options: {
                    method: 'PUT',
                    body: JSON.stringify(item),
                },
                id
            }
        )
    }

    static async count(query={}) {
        let { count=null } = await this.getFetch({query: {...query, limit: 1}}).then(r => r.json())
        return count
    }

    static defaultFilter(collection) {
        return collection.where({cuit: user.currentAccount})
    }

    // static async batchInitialization({count=null, size=20, page=0, delay=0}) {
    //     if (typeof count != 'number') {
    //         count = await this.count()
    //     }
    //     const postProcess = async r => await r.json()
    //         // .then(d => {console.log(d); return d})
    //         .then(d => this.toItem(d))
    //         .then(d => d.map(e => this.convert(e)))
    //     let totalPages = Math.ceil(count/size)
    //     let firstBatch = this.get({ limit: size, page }).then(postProcess)
    //     const selfClass = this
    //     let cdate = new Date()
    //     console.log(`[${selfClass.name}] Start batch at ${cdate.toISOString()}`)
    //     let restBatchsBuilder = (initialIter, total, limit, mclass, thenFunc, awaitTime) => async function* () {
    //         let iter = initialIter
    //         while (iter <= total) {
    //             console.log(`[${selfClass.name}] Sync Page ${iter} of ${total}`)
    //             try {
    //                 if(awaitTime) await sleep(awaitTime);
    //                 yield await mclass.get({ limit, page: iter, 'creation_date[lte]': cdate.toISOString() }).then(thenFunc)
    //                 iter++
    //             } catch (e) {
    //                 break
    //             }
    //         }
    //     }
    //     return [firstBatch, restBatchsBuilder(1, totalPages, size, selfClass, postProcess, delay)]
    // }

    static sync(collection, since = 0) {
        let date = new Date(since * 1000).toISOString().replace('Z', '+0000')
            return this.getFetch({
                options: {
                    method: 'GET',
                },
                query: {
                    'modified_date[gt]': date,
                    fields: 'id,id_oferta,id_licitacion,id_siniestro,state,siniestro,codigo_infoauto,sucursal_nombre,licitacion,claims,creation_date,modified_date,offer_modifications,monto_total,tiempo_entrega,items,asegurado,vehiculo,siniestro'
                }
            }).then(async (r) => {
                if (r.ok) {
                    let { data } = await r.json()
                    data.forEach((item) => {
                        collection.put(this.convert(item))
                    })
                }
                return r
            })
    }
}

export class Sucursal {
    static URL = ({ cuit = null, id = null, query = null }) => {
        query = query !== null ? new URLSearchParams(query).toString() : null
        let ret = [
            `${API_URL}/branchoffices/`,
            cuit !== null ? `${cuit}/` : '',
            id !== null ? `${id}/` : '',
            query !== null ? `?${query}` : '',
        ]
            .filter((x) => x !== '')
            .join('')
        return ret
    }
    static getFetch = (options, { cuit = null, id = null, query = null }) => {
        return user.fetch(this.URL({ cuit, id, query }), options)
    }
    static convert(data) {
        return {
            fecha_modificacion: Math.floor(
                new Date(data.modified_date).getTime() / 1000
            ),
            cuit: user.currentAccount,
            ...data,
        }
    }

    static async count(query={}) {
        let { count=null } = await this.getFetch({query: {...query, limit: 0}}).then(async r => r.json())
        return count
    }

    static toItem(returnedFetchData) {
        return returnedFetchData?.data || []
    }

    static get(query = {}) {
        return this.getFetch(
            {
                method: 'GET',
            },
            { cuit: user.currentAccount, query }
        )
    }

    static getById(id) {
        return this.getFetch(
            {
                method: 'GET',
            },
            { cuit: user.currentAccount, id }
        )
    }

    static add(item) {
        //TODO REVISAR
        return this.getFetch(
            {
                method: 'POST',
                body: JSON.stringify(item),
            },
            { cuit: user.currentAccount }
        )
    }

    static update(id, item) {
        return this.getFetch(
            {
                method: 'PUT',
                body: JSON.stringify(item),
            },
            { cuit: user.currentAccount, id }
        )
    }

    static sync(collection, since = 0) {
        let date = new Date(since * 1000).toISOString().replace('Z', '+0000')
        return this.getFetch(
            {
                method: 'GET',
            },
            {
                cuit: user.currentAccount,
                query: { 'modified_date[gt]': date },
            }
        ).then(async (r) => {
            if (r.ok) {
                let { data } = await r.json()
                data.forEach((item) => {
                    collection.put(this.convert(item))
                })
            }
            return r
        })
    }
}
